import { UserManager, WebStorageStateStore } from 'oidc-client';
import Routes from '../../constants/routes';
import { hasSucceeded } from '../../constants/async-status';
import store from '../../app/store';
import { CookieHelper } from '../../utils/helper/cookie-helper';

let IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL: string;
let LOGIN_CLIENT_ID: string;
let USE_KEYCLOAK: boolean;
let KEYCLOAK_DOMAIN_URL: string;
let KEYCLOAK_LOGIN_CLIENT_ID: string;

let LOGIN_BASE_URL: string;
let AUTH0_AUDIENCE: string;

const BASE_APP_URL = window.location.origin;
const IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK = `${BASE_APP_URL}${Routes.LOGOUT}`;
const IDENTITY_PROVIDER_CALLBACK = `${BASE_APP_URL}${Routes.LOGIN_CALLBACK}`; // 'nvc-nonprod.clinicallearninghub.com/callback';
const KEYCLOAK_PROTOCOL = 'protocol/openid-connect';

const getValuesfromStore = () => {
    store.subscribe(() => {
        const valuesFromStore = store.getState().appConfigs;
        if (
            Object.keys(valuesFromStore.appConfigs).length > 0 &&
            hasSucceeded(valuesFromStore.appConfigsAsyncStatus)
        ) {
            USE_KEYCLOAK = valuesFromStore.appConfigs.USE_KEYCLOAK === 'true';
            KEYCLOAK_DOMAIN_URL =
                valuesFromStore.appConfigs.KEYCLOAK_DOMAIN_URL;
            KEYCLOAK_LOGIN_CLIENT_ID =
                valuesFromStore.appConfigs.KEYCLOAK_LOGIN_CLIENT_ID;
            IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL =
                valuesFromStore.appConfigs.IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL;
            LOGIN_CLIENT_ID = valuesFromStore.appConfigs.LOGIN_CLIENT_ID;
            LOGIN_BASE_URL = valuesFromStore.appConfigs.CLH_BASE_URL;
            AUTH0_AUDIENCE = valuesFromStore.appConfigs.AUTH0_AUDIENCE;
        }
    });
};
getValuesfromStore();

const getKeycloakConfig = () => ({
    authority: KEYCLOAK_DOMAIN_URL,
    client_id: KEYCLOAK_LOGIN_CLIENT_ID,
    redirect_uri: `${BASE_APP_URL}/authentication/login-callback`,
    response_type: 'code',
    scope: 'openid profile email',
    filterProtocolClaims: false,
    loadUserInfo: false,
    accessTokenExpiringNotificationTime: 5,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    metadata: {
        issuer: `${KEYCLOAK_DOMAIN_URL}`,
        authorization_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/auth`,
        token_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/token`,
        userinfo_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/userinfo`,
        jwks_uri: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/certs`,
        end_session_endpoint: `${KEYCLOAK_DOMAIN_URL}/${KEYCLOAK_PROTOCOL}/logout?client_id=${KEYCLOAK_LOGIN_CLIENT_ID}&post_logout_redirect_uri=${encodeURIComponent(
            LOGIN_BASE_URL
        )}`,
    },
});

// I think we should leave this chunk of code in here for if
// we choose to change Login's auth0 setup from RWA to SPA

// const getConfig = () => ({
//     authority: IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL,
//     client_id: LOGIN_CLIENT_ID,
//     client_secret: process.env.AUTH0_API_SECRET,
//     redirect_uri: IDENTITY_PROVIDER_CALLBACK,
//     response_type: 'code',
//     scope: 'openid profile email',
//     filterProtocolClaims: false,
//     loadUserInfo: false,
//     accessTokenExpiringNotificationTime: 5,
//     userStore: new WebStorageStateStore({ store: window.sessionStorage }),
//     metadata: {
//         issuer: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/`,
//         authorization_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/authorize`,
//         token_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/oauth/token`,
//         userinfo_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/userinfo`,
//         jwks_uri: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/.well-known/jwks.json`,
//         end_session_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/v2/logout?client_id=${LOGIN_CLIENT_ID}&returnTo=${encodeURIComponent(
//             IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK
//         )}`,
//     },
// });

const getConfig = () => ({
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    authority: IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL,
    client_id: LOGIN_CLIENT_ID,
    redirect_uri: IDENTITY_PROVIDER_CALLBACK,
    response_type: 'id_token token',
    scope: 'openid profile',
    post_logout_redirect_uri: IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK,
    automaticSilentRenew: true,
    silent_redirect_uri: IDENTITY_PROVIDER_CALLBACK,
    includeIdTokenInSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: false,
    metadata: {
        issuer: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/`,
        authorization_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/authorize`,
        token_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/oauth/token`,
        userinfo_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/userinfo`,
        jwks_uri: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/.well-known/jwks.json`,
        end_session_endpoint: `${IDENTITY_PROVIDER_CUSTOM_DOMAIN_URL}/v2/logout?client_id=${LOGIN_CLIENT_ID}&returnTo=${encodeURIComponent(
            IDENTITY_PROVIDER_POST_LOGOUT_CALLBACK
        )}`,
    },
    extraQueryParams: {
        audience: AUTH0_AUDIENCE,
    },
});

const appUserManagerSetup = async () => {
    let oidcConfig;
    if (USE_KEYCLOAK) {
        oidcConfig = await getKeycloakConfig();
    } else {
        oidcConfig = await getConfig();
    }
    const appUserManager = new UserManager(oidcConfig);

    appUserManager.events.addAccessTokenExpiring(() => {
        console.log('token expiring...');
    });
    appUserManager.events.addAccessTokenExpired(() => {
        console.log('token expired...');
    });
    appUserManager.events.addSilentRenewError((e) => {
        console.log('silent renew error', e.message);
    });
    appUserManager.events.addUserLoaded(() => {
        CookieHelper.removeCookie();
        console.log('user loaded');
    });
    appUserManager.events.addUserUnloaded(() => {
        CookieHelper.setCookie();
        console.log('user cleared');
    });
    return appUserManager;
};

export default appUserManagerSetup;
